export const style = {
  label: {
    fontSize: `14px`,
    fontWeight: 300,
    marginBottom: `5px`
  },
  input: {
    color: `#555`,
    fontSize: `14px`,
    padding: `0 12px`,
    border: `#e6e6e6 2px solid`,
    borderRadius: 0,
    ':focus': {
      borderColor: `#c6c6c6`
    }
  },
  textArea: {
    padding: `10px 12px`
  },
  inputError: {
    borderColor: `#a94442`
  },
  singleRowInput: {
    height: `38px`
  },
  submit: {
    fontSize: `16px`,
    color: `white`,
    padding: `5px 16px`,
    background: `#AD5251`,
    border: `#AD5251 2px solid`,
    cursor: `pointer`,
    ':focus': {
      transition: `0.2s`,
      background: `white`,
      color: `#AD5251`
    }
  },
  select: {
    padding: `8px 15px`,
    border: `#e6e6e6 2px solid`,
    width: `100%`,
    height: `auto`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/form.js